var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.032,
    height: 25.032,
    viewBox: "0 0 25.032 25.032",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25789",
    "data-name": "Group 25789",
    transform: "translate(114.684 -0.591)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37345",
    "data-name": "Path 37345",
    d: "M-102.168,25.623a12.529,12.529,0,0,1-12.516-12.516A12.53,12.53,0,0,1-102.168.591,12.53,12.53,0,0,1-89.652,13.107,12.529,12.529,0,0,1-102.168,25.623Zm0-23.735a11.231,11.231,0,0,0-11.219,11.219,11.231,11.231,0,0,0,11.219,11.219A11.231,11.231,0,0,0-90.949,13.107,11.231,11.231,0,0,0-102.168,1.888Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25788",
    "data-name": "Group 25788",
    transform: "translate(-110.649 8.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37346",
    "data-name": "Path 37346",
    d: "M-109.963,17.677h1.419V11.351h-1.473V9.729h3.244v7.948h1.311v1.514h-4.5Z",
    transform: "translate(110.017 -9.567)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37347",
    "data-name": "Path 37347",
    d: "M-102.653,14.285a2.083,2.083,0,0,1-1.189-1.864c0-1.907,1.757-2.879,3.811-2.879s3.879.986,3.879,2.879a1.939,1.939,0,0,1-1.217,1.784,2.375,2.375,0,0,1,1.433,2.109c.041,2.2-1.987,3.082-4.095,3.068-2.054-.014-4.109-.852-4.069-3.068A2.288,2.288,0,0,1-102.653,14.285Zm.419,2.054c-.014.73.77,1.42,2.216,1.42s2.231-.675,2.217-1.42c-.013-.932-1.027-1.351-2.217-1.351C-101.125,14.988-102.22,15.408-102.233,16.34Zm2.216-2.648c1.1,0,1.974-.5,2-1.325.027-.8-.811-1.338-2.014-1.338-1.338,0-2.014.688-1.987,1.338C-101.99,13.192-101.057,13.691-100.017,13.691Z",
    transform: "translate(109.216 -9.542)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37348",
    "data-name": "Path 37348",
    d: "M-92.633,11.339V9.729h1.307v1.61h1.609v1.2h-1.609v1.62h-1.307v-1.62h-1.588v-1.2Z",
    transform: "translate(107.879 -9.567)",
    fill: "#333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAge);
export default __webpack_public_path__ + "static/media/icon-age.9845249c82edb4fb694e5c519b4f76e9.svg";
export { ForwardRef as ReactComponent };